import { render, staticRenderFns } from "./LeftView.vue?vue&type=template&id=58ca844a&scoped=true"
import script from "./LeftView.vue?vue&type=script&lang=js"
export * from "./LeftView.vue?vue&type=script&lang=js"
import style0 from "./LeftView.vue?vue&type=style&index=0&id=58ca844a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ca844a",
  null
  
)

export default component.exports